var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 965.67 1407.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: none;\r\n                stroke: #b5d7e5;\r\n                stroke-linecap: round;\r\n                stroke-linejoin: round;\r\n                stroke-width: 3px;\r\n            }\r\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.83,454.83V286.52a60,60,0,0,0-120,0v26.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452.33,555.41a57.21,57.21,0,1,1-57.5,57.21V483.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M869.83,618.83h-84c-60.75,0-110,49.7-110,111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.83,991.83c0,32-25.74,58-57.5,58s-57.5-26-57.5-58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674,1217.29c-21.34,79.82,24.84,161.56,103.14,182.58s159.1-26.65,180.44-106.46-24.83-161.55-103.13-182.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M824.82,862.83c0,33.69,26.87,61,60,61s60-27.31,60-61-26.85-61-60-61h-201"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.75,1346.83c0-32,25.77-58,57.54-58s57.54,26,57.54,58-25.76,58-57.54,58H243.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.48,719.83c56,0,101.35-46.11,101.35-103s-45.37-103-101.35-103H595.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.83,652.83V884.47c0,69.24,56.64,125.36,126.5,125.36s126.5-56.12,126.5-125.36V829.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.64,1044.83c79.08,0,143.19,64.48,143.19,144s-64.11,144-143.19,144H5.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.83,1236.83c0-58.54,46.85-106,104.64-106H670.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.33,741.83v152"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.33,1154.83v62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.83,579.83V722.17A40.69,40.69,0,0,1,555,762.7a40.71,40.71,0,0,0-40.86,40.55v8.41A40.7,40.7,0,0,0,555,852.21a40.71,40.71,0,0,1,40.86,40.56v9.31a50,50,0,0,1-50.24,49.86H481.41M316.83,1084.83h26.78A100.12,100.12,0,0,0,443.8,984.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M962.83,147.83c-39.76,0-72-32.45-72-72.5s32.24-72.5,72-72.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 60.83,
    cy: 1188.33,
    rx: 58,
    ry: 57.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.83,788.33V699a46.34,46.34,0,0,1,46.5-46.17h0A46.33,46.33,0,0,1,283.83,699V877.67a46.32,46.32,0,0,1-46.5,46.16h0a46.33,46.33,0,0,1-46.5-46.16V856.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M812.33,1199.67c31.76,0,57.5,25.56,57.5,57.08s-25.74,57.08-57.5,57.08-57.5-25.56-57.5-57.08V884.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.83,382.76V403a51.87,51.87,0,0,1-51.94,51.79h0A51.87,51.87,0,0,1,739.94,403v-16.8a51.49,51.49,0,0,0-51.55-51.41h0a51.49,51.49,0,0,0-51.56,51.41v20.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.83,886.83v53.76a98.26,98.26,0,0,1-98.28,98.24H508.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.83,1278.8a73,73,0,0,1,73-73h0a73,73,0,0,1,73,73v53.07a73,73,0,0,1-73,73h0a73,73,0,0,1-73-73Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/Sidebar-bg.0fb1d04ac8e18ae26b89283529e1d10d.svg";
export { ForwardRef as ReactComponent };